import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {GeliosFieldBaseComponent} from "../gelios-field-base/gelios-field-base.component";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-map-coordinate-field',
  templateUrl: './gelios-map-coordinate-field.component.html',
})
export class GeliosMapCoordinateFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  @Output() setPositionButtonClicked: EventEmitter<any> = new EventEmitter();
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}
